// v5 builds the main toolbar before plugins start, and string names in
// buttons.toolbar are dropped unless they exist on buttonsObj. Register both
// so a rebuild after init keeps toolbar order, and the context bar can add them later.
const extraButtonClasses = new Map()

export function registerToolbarButton(app, name, config) {
    const button = { ...config, name }
    // v5 does classList.add(classname) and rejects space-separated tokens.
    const classes = String(button.classname || '')
        .split(/\s+/)
        .filter(Boolean)
    if (classes.length) {
        button.classname = classes[0]
        extraButtonClasses.set(name, classes)
    }
    const buttonsObj = app.getOption('buttonsObj')
    if (buttonsObj && typeof buttonsObj === 'object') {
        const withoutPosition = { ...button }
        delete withoutPosition.position
        buttonsObj[name] = withoutPosition
    }
    app.toolbar.add(name, button)
    if (app.context && typeof app.context.add === 'function') {
        app.context.add(name, button)
    }
}

export function applyExtraButtonClasses(app) {
    extraButtonClasses.forEach((classes, name) => {
        ;['toolbar', 'context', 'control'].forEach((slot) => {
            const button = app[slot] && app[slot].getButton && app[slot].getButton(name)
            const el = button && button.getEl && button.getEl()
            if (el) el.classList.add(...classes)
        })
    })
}

export function setToolbarButtonHtml(app, name, html) {
    const button = app.toolbar.getButton(name)
    if (!button) return
    button.html = html
    const el = button.getEl && button.getEl()
    if (el) el.innerHTML = html
}

export function computedStyle(el, prop) {
    if (!el || el.nodeType !== 1) return ''
    const view = (el.ownerDocument && el.ownerDocument.defaultView) || window
    return view.getComputedStyle(el).getPropertyValue(prop)
}
